<template>
  <div>
    <div class="row text-center" v-if="!dataLoaded">
      <div class="col">
         <span
             class="spinner-border"
             role="status"
         >
          <span class="sr-only">Loading...</span>
      </span>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col">
        <div v-for="task in tasks">
          <task-item
              :task="task"
              :key="`summary-${task.type}-${task.id}`"
              :labelOptions="labelOptions"
              :viewOnly="true"
              :isPersonal="true"
          ></task-item>
        </div>
      </div>
    </div>

    <GoalList
        :yourGoals="yourGoals"
        @storeTasksLocally="storeTasksLocally"
    />

    <div class="row">
      <div class="col">
        <div class="text-center">
          <button
              class="btn btn-link font-weight-bold p-0"
              :disabled="page >= last_page || this.tasks.length === 0"
              @click="fetchNextTasks()"
          >
            Show more
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Task from '../Task';
import { store } from '../../../services/taskService';
import GoalList from './GoalList';
import AddPlusIcon from '../../../icons/AddPlusIcon';

export default {
  name: 'PersonalTaskSummaryList',

  components: { AddPlusIcon, GoalList },

  props: ['yourTodoTasks', 'yourGoals'],

  data () {
    return {
      tasks: [],
      taskService: Task,
      dataLoaded: !!this.tasks,
      page: 1,
      last_page: null,
    };
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    labelOptions () {
      return this.$store.state.labelOptions;
    },

    disabledAddTask () {
      return !(this.addNewTodoTaskFocused || this.addNewTodoTaskTitle);
    },

    inputClass () {
      return { 'bg-light': this.disabledAddTask, 'border-0': this.disabledAddTask };
    },
  },

  methods: {
    storeTasksLocally (eventData) {
      this.$emit('storeTasksLocally', eventData);
    },

    fetchNextTasks () {
      this.page++;
      this.fetchTasks();
    },

    async fetchTasks () {
      const res = await this.taskService.fetchTasks({
        assigned_to: 'personal',
        range: 'today',
        status: 'today',
        page: this.page,
      });
      let tasks = res.data;
      let tasksWithSubtasks = [];

      tasks.forEach((item) => {
        if (item.total_subtasks > 0) {
          tasksWithSubtasks.push(item.id);
        }
      });

      if (tasksWithSubtasks.length > 0) {
        const res = await axios.get('/task/subtasks', {
          params: {
            ids: tasksWithSubtasks.join(','),
          },
        });
        const subtasks = res.data.data;

        tasks = tasks.map((item) => {
          const subtask = subtasks[item.id];

          if (!!subtask) {
            item['subtasks'] = subtask;
          }

          return item;
        });
      }

      this.page = res.current_page;
      this.last_page = res.last_page;
      this.tasks = [
        ...this.tasks,
        ...tasks,
      ];
      this.dataLoaded = true;
    },

    reset () {
      this.tasks = [];
      this.page = 1;
      this.dataLoaded = false;
    },

    registerTaskUpdatedListener () {
      window.Echo.private(`tasks-updated.${this.currentUser.company.id}`).listen(
          '.tasks-updated',
          e => {
            this.reset();
            this.fetchTasks();
          },
      );
    },
  },

  mounted () {
    this.registerTaskUpdatedListener();
    this.fetchTasks();
  },
};
</script>

<style scoped>
.btn-link {
  padding: 0 !important;
  color: #0db4e6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}
label {
  font-family: "Open Sans", sans-serif;
}
</style>
